import { render, staticRenderFns } from "./VisitorDocumentsBlock.vue?vue&type=template&id=38bca5c0"
import script from "./VisitorDocumentsBlock.vue?vue&type=script&lang=js"
export * from "./VisitorDocumentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports